import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "../UIComponents/AddIcon";
import axios from "axios";
import API from "../helpers/api";
import { getClientUsersList, getCompanynameList } from "../Actions/HelpersAPI";
import { searchShipMgmt } from "../Actions/ShipManagementAPI";
import swal from "sweetalert";
import { toast } from "react-toastify";

let searchData = {
  ShipName: "",
  PageNumber: 1,
  PageSize: 25,
  isActive: true,
  isInactive: false,
  isAll: false
};

class ShipManagementAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipInfo: {
        shipName: "",
        shipMail: "",
        imoNo: "",
        vesselGroupMail: "",
        createdBy: "",
        clientName: "",
        shipUsers: [],
        isActive: true
      },
      fleetmanager: "",
      superintendent: "",
      technicalexecutive: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCompanyInputChange = this.handleCompanyInputChange.bind(this);
    this.AddShip = this.AddShip.bind(this);
  }
  componentDidMount() {
    this.props.dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    this.props.dispatch(getCompanynameList());
  }


  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.setState(prevState => ({
        shipInfo: {
          ...prevState.shipInfo,
          isActive: true
        }
      }));
    }
    else {
      this.setState(prevState => ({
        shipInfo: {
          ...prevState.shipInfo,
          isActive: false
        }
      }));
    }
  }
  handleCheckBoxChange1(e) {
    if (e.target.checked) {
      this.setState(prevState => ({
        shipInfo: {
          ...prevState.shipInfo,
          isActive: false
        }
      }));
    }
    else {
      this.setState(prevState => ({
        shipInfo: {
          ...prevState.shipInfo,
          isActive: true
        }
      }));
    }
  }


  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { fleetManagerlist, TechExecutivelist, TechSuperintendentlist, dispatch } = nextProps;
  //   if (fleetManagerlist) {
  //     prevState.FleetManager = fleetManagerlist;
  //   }
  //   if (TechSuperintendentlist) {
  //     prevState.TechSuperintendent = TechSuperintendentlist;
  //   }
  //   if (TechExecutivelist) {
  //     prevState.TechExecutive = TechExecutivelist;
  //   }
  // if (clientId && clientId !== "") {
  //   prevState.FleetManager.clientId = clientId;
  //   prevState.TechSuperintendent.clientId = clientId;
  //   prevState.TechExecutive.clientId = clientId;
  //   let users = [prevState.FleetManager, prevState.TechSuperintendent, prevState.TechExecutive];
  //   console.log("users", users);
  // }
  // }
  vesselmailvalid = () => {
    let flag = true;
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.state.shipInfo.vesselGroupMail !== '') {
      if (emailregex.test(this.state.shipInfo.vesselGroupMail)) {
        flag = true;
      }
      else {
        flag = false;
      }
    }
    return flag;
  }

  AddShip() {
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { dispatch } = this.props;
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (this.state.shipInfo.clientName !== "" && this.state.shipInfo.imoNo !== "" && this.state.shipInfo.shipName !== "" && this.state.shipInfo.shipMail !== "") {
      if (this.state.shipInfo.shipMail !== "") {
        if (emailregex.test(this.state.shipInfo.shipMail)) {
          if (this.vesselmailvalid()) {
            let url2 = `${API.userExist}?Mail=${this.state.shipInfo.shipMail}`;
            axios
              .get(url2, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                if (response.data === true) {

                  let url = `${API.PostShip}`;
                  let data = {
                    shipName: this.state.shipInfo.shipName,
                    shipMail: this.state.shipInfo.shipMail,
                    imoNo: this.state.shipInfo.imoNo,
                    vesselGroupMail: this.state.shipInfo.vesselGroupMail,
                    createdBy: currentUser.email,
                    clientName: this.state.shipInfo.clientName,
                    shipUsers: this.state.shipInfo.shipUsers,
                    isActive: this.state.shipInfo.isActive
                  };
                  axios
                    .post(url, data, {
                      headers: {
                        key: currentUser.accessToken,
                      },
                    })
                    .then((response) => {
                      if (response.status === 500) {
                        swal("Error!", "Error when adding the data. Try again.", "warning");
                      } else {
                        this.CancelAddship();
                        toast.success("Added Successfully", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                        dispatch(searchShipMgmt(searchData));
                        dispatch({
                          type: "PostShipDetailSuccess",
                          data: response.data,
                        });
                      }
                    })
                    .catch((error) => {
                      swal("Error!", "Something went wrong. Please try again.", "warning");
                      dispatch({
                        type: "PostShipDetailFailure",
                        data: "error",
                      });
                    });


                } else if (response.data === false) {
                  swal(
                    "Error!",
                    "User already exist. Please change the ship email",
                    "warning"
                  );
                  this.state.shipInfo.shipMail = "";
                  this.setState({});
                }
                dispatch({
                  type: "getUserExistListSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "getUserExistListFailure",
                  data: "error",
                });
              });
          }
          else {
            swal("Error!", "Invalid email format(Vessel Mail)", "warning");
          }
        }
        else {
          swal("Error!", "Invalid email format(Ship Mail)", "warning");
        }
      }
    } else if (this.state.shipInfo.shipName === "") {
      swal('Error!', 'Ship Name is mandatory', 'warning');
    }
    else if (this.state.shipInfo.imoNo === "") {
      swal('Error!', 'IMO Number is mandatory', 'warning');
    } else if (this.state.shipInfo.shipMail === "") {
      swal("Error!", "Email is mandatory", "warning");
    }
    else if (this.state.shipInfo.clientName === "") {
      swal("Error!", "Company Name is mandatory", "warning");
    }

  }

  CancelAddship() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Ship");
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.shipInfo[nodeName] = e.target.value;
    this.setState({});
  }

  handleCompanyInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fleetmanager") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "fleetmanager",
      });
    } else if (nodeName === "superintendent") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "superintendent",
      });
    } else if (nodeName === "technicalexecutive") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "technicalexecutive",
      });
    } else if (nodeName === "clientName") {
      this.state.fleetmanager = "";
      this.state.superintendent = "";
      this.state.technicalexecutive = "";
      this.state.shipInfo[nodeName] = e.target.value;
      this.props.dispatch(getClientUsersList(e.target.value));
    }
    this.setState({});
  }

  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const {
      showSidePane,
      ClientUsersList,
      ClientNameList,
      fleetManagerList,
      TechSuperintendentList,
      TechExecutiveList,
    } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-1 pl-3 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Basic Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Name</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipName"
                      placeholder="Ship Name"
                      value={this.state.shipInfo.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">IMO No</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      placeholder="IMO No"
                      value={this.state.shipInfo.imoNo}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Ship Email</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipMail"
                      placeholder="Ship Email"
                      value={this.state.shipInfo.shipMail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <div className="row"></div>
                    <label className="form-label">
                      Vessel Group Email{" "}
                      {/* <span className="font-weight-normal">(Optional)</span> */}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="vesselGroupMail"
                      placeholder="Vessel Group Email"
                      value={this.state.shipInfo.vesselGroupMail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Is Active</label>
                    <br></br>
                    <div className="d-flex align-items-center">
                      <input
                        style={{ height: '20px', width: '20px' }}
                        type="checkbox"
                        name="isAdmin"
                        id="activeyes"
                        className="mr-2"
                        checked={this.state.shipInfo.isActive}
                        onChange={(e) => this.handleCheckBoxChange(e)}
                      ></input>
                      <label htmlFor="activeyes" className="form-label mr-3">Yes</label>
                      <input
                        style={{ height: '20px', width: '20px' }}
                        type="checkbox"
                        name="isAdminno"
                        id="activeno"
                        className="mr-2"
                        checked={!this.state.shipInfo.isActive}
                        onChange={(e) => this.handleCheckBoxChange1(e)}
                      ></input>
                      <label htmlFor="activeno" className="form-label">No</label>
                    </div>
                  </div>
                </div>
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-1 pl-3 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Company Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label required">Company Name</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="clientName"
                      value={this.state.shipInfo.clientName}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Company Name</option>
                      {ClientNameList &&
                        ClientNameList.map((i) => (
                          <option value={i.clientName}>{i.clientName}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">Marine Manager</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="fleetmanager"
                      value={this.state.fleetmanager}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Marine Manager</option>
                      {fleetManagerList ? (
                        fleetManagerList.map((i) => (
                          <option value={i.userName}>{i.userName}</option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      Marine Superintendent
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="superintendent"
                      value={this.state.superintendent}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select Marine Superintendent</option>
                      {TechSuperintendentList ? (
                        TechSuperintendentList.map((i) => (
                          <option value={i.userName}>{i.userName}</option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">DPA</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="technicalexecutive"
                      value={this.state.technicalexecutive}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">Select DPA</option>
                      {TechExecutiveList ? (
                        TechExecutiveList.map((i) => (
                          <option value={i.userName}>{i.userName}</option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="pb-4 pl-4 pr-4">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.AddShip()}
                    >
                      {" "}
                      Submit{" "}
                    </button>
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.CancelAddship()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    fleetManagerList: state.MasterScreenReducer.fleetManagerList,
    TechSuperintendentList: state.MasterScreenReducer.techSuperintendentList,
    TechExecutiveList: state.MasterScreenReducer.techExecutiveList,
    ClientUsersList: state.MasterScreenReducer.ClientUsersList,
    ClientNameList: state.UserManageReducer.CompanyList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ShipManagementAdd);
